interface DefaultArrowSelectProps {
  className?: string;
  color?: string;
}

const FileIcon = ({ color, className }: DefaultArrowSelectProps) => {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill={color} className={className}>
        <path fillRule="evenodd" clipRule="evenodd" d="M6.50263 0.200644L2.47263 4.05464C2.46117 4.06583 2.45012 4.07732 2.43948 4.08909C2.32404 4.18067 2.25 4.32219 2.25 4.481C2.25 4.49603 2.25066 4.5109 2.25196 4.52558C2.25079 4.5423 2.2502 4.55911 2.2502 4.576V14.612C2.2502 15.3784 2.8723 16 3.6392 16H12.3622C13.1291 16 13.7512 15.3784 13.7512 14.612V1.389C13.7512 0.622599 13.1291 0 12.3622 0H7.0012C6.98284 0 6.96458 0.000706739 6.94645 0.00210092C6.93544 0.00137374 6.92433 0.00100294 6.91313 0.000999964C6.76576 0.000960738 6.63326 0.0646843 6.54173 0.166098C6.53021 0.175573 6.51895 0.185412 6.50797 0.195603L6.50263 0.200644ZM6.41269 1.67032L3.99647 3.981H6.41207L6.41269 1.67032ZM3.2502 4.981V14.612C3.2502 14.8259 3.42441 15 3.6392 15H12.3622C12.577 15 12.7512 14.8259 12.7512 14.612V1.389C12.7512 1.17471 12.5766 1 12.3622 1H7.41287L7.412 4.258C7.412 4.65714 7.08814 4.981 6.689 4.981H3.2502Z" fill={color} />
      </svg>
    </>
  );
}

export default FileIcon;